import styled from 'styled-components';
import { rem } from 'polished';
import Select from '@molecules/Select/Select';
import variables from '@styles/variables';
import Text from '@atoms/Text/Text';
import PageLayout from '@organisms/PageLayout/PageLayout';
import Button from '@atoms/Button/Button';
import Config from '@config';

export const StyledSelect = styled(Select)`
  width: 100%;
  margin: ${rem(32)} 0;
  padding: 0 ${rem(20)};

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    padding: 0;
    width: ${rem(162)};
    margin: 0 0 ${rem(32)} auto;
  }
`;

export const StyledCategoryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  background-color: ${variables.colors.lighterGray};
  padding: ${rem(16)} ${rem(20)};

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    padding: ${rem(16)} ${rem(32)};
  }
`;

export const StyledHeadingStore = styled(Text)`
  width: 100%;

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    width: 60%;
  }
`;

export const StyledHeadingCity = styled(Text)`
  width: 20%;

  ${Config.MEDIA.IS_MOBILE} {
    display: none;
  }
`;

export const StyledHeadingOpeningHours = styled(Text)`
  width: 20%;
  text-align: right;

  ${Config.MEDIA.IS_MOBILE} {
    display: none;
  }
`;

export const StyledBodyOpeningHours = styled(Text)`
  margin: ${rem(5)} 0;
`;

export const StyledStoresWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledStoreItem = styled.div`
  display: flex;
  padding: ${rem(20)} ${rem(20)};
  border-bottom: ${rem(1)} solid ${variables.colors.mediumGray};

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    padding: ${rem(20)} ${rem(32)};
  }
`;

export const StyledStoreInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: ${rem(15)};

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    width: 60%;
  }
`;

export const StyledPageLayout = styled(PageLayout)`
  margin-top: ${rem(40)};
  margin-bottom: ${rem(32)};

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    margin-top: ${rem(80)};
    margin-bottom: ${rem(100)};
  }
`;

export const StyledShowMoreButton = styled(Button)`
  margin: ${rem(32)} auto 0;

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    margin: ${rem(60)} auto 0;
  }
`;
